// extracted by mini-css-extract-plugin
export var currencyInput = "_ng-1";
export var currencySymbol = "_ng-0";